import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { FieldConfig } from '../models/field-config';
import { FieldType } from '../models/field-type';
import { FormService } from './form.service';
import { FormConfig } from '../models/form-config';
import { SubmitValidateFormService } from './submit-validate-form.service';

export class FormFactoryService {

  initBean: any;
  formGroup: FormGroup;
  resultBean: any = {};
  fieldType = FieldType;
  fields: FieldConfig[];
  formConfig: FormConfig;
  formService: FormService;
  errorsMap: Map<string, string[]> = new Map();
  controls = new Map<string, AbstractControl>();
  submitValidateFormService: SubmitValidateFormService;

  constructor(formConfig: FormConfig, bean?: any) {
    this.initBean = bean;
    this.formConfig = formConfig;

    this.formService = new FormService();
    this.fields = this.formService.generateArray(this.formConfig, this.initBean);
  }

  buildFormGroup(formGroup: FormGroup) {
    if (this.fields != null) {
      this.fields.forEach(item => {
        this._configureField(item, formGroup);
      });
    }

    this.formGroup = formGroup;
    this.submitValidateFormService = new SubmitValidateFormService(this.formGroup.controls, this.formConfig, this.errorsMap);
  }

  fieldConfig(fieldKey: string, formConfig?: FormConfig) {
    let formConfigTmp;

    if (formConfig) {
      formConfigTmp = formConfig;
    } else {
      formConfigTmp = this.formConfig;
    }
    return this.formService.getConfigForField(fieldKey, formConfigTmp);
  }

  isFormValid(): boolean {
    return this.formGroup.valid;
  }

  submitForm(): void {
    this.submitValidateFormService.markAsTouchFields();
    this.formService.convertDateToLong(this.formGroup.value, this.formConfig);
    this.submitValidateFormService.fillErrorMap();

    if (!this.formGroup.valid) {
      this.submitValidateFormService.showErrors();
    }
  }

  validateField(fieldKey: string) {
    this.submitValidateFormService.validateField(fieldKey);
  }

  validateSection() {
    this.submitValidateFormService.markAsTouchFields();
    this.submitValidateFormService.fillErrorMap();
    this.submitValidateFormService.showErrors();
  }

  discardForm(): void {
    this.errorsMap.clear();
    this.formGroup.reset();
  }

  clearError(fieldKey: string): void {
    this.errorsMap.delete(fieldKey);
  }

  private _configureField(item: any, form: FormGroup) {
    const key: string = item.key;
    const config = this.formService.getConfigForField(key, this.formConfig);
    if (config !== undefined) {
      if (config.type !== this.fieldType.FormsArray) {
        const newControl = new FormControl('', this.formService.getValidators(config.validators, config));
        form.addControl(key, newControl);
        if (config.disabled) {
          newControl.disable();
        } else if (config.type === FieldType.DateField) {
          item.value = this.formService.getDate(item.value, item.config);
          newControl.setValue(item.value);
        } else {
          newControl.setValue(item.value);
        }

        if (config.fieldsDataFormat === 'objectArray') {
          const beanPropertyValue = newControl.value[config.beanConfig.propertyName];
          if (beanPropertyValue) {
            newControl.setValue(beanPropertyValue[key]);
          }
        }

        newControl.valueChanges.subscribe(() => {
          this.errorsMap.delete(key);
        })
      } else {
        const newControl: AbstractControl = new FormArray([]);
        form.addControl(key, newControl);
      }
    }
  }
}
